import React, { FC, useEffect, useState } from 'react';
import imgURL from '../../lib/imgURL';
import { TextInputProps } from './typings';
import './style.scss';
import { Tooltip } from 'antd';

const TextInput: FC<TextInputProps> = (props): JSX.Element => {
  const {
    label,
    type,
    value,
    placeholder,
    bgIcon,
    bgText,
    bgIconPosition = 'left',
    id,
    onBlur = () => { },
    handleChange = () => { },
    maxlength,
    className,
    error,
    errorMessage,
    isRequired,
    readonly,
    style = {},
    formGroupClassName,
    forgotPassword,
    sideNote = '',
    labelTooltip,
    isMasked = false,
    allowToggleVisibility = true,
    allowPaste = true,
    insideBtn = false,
    insideBtnTxt = '',
    customInsideBtnClass = '',
    insideBtnOnClick = () => { },
    verified = false,
    verifiedMessage = '',
    showAiHelperOnFocus = false,
    onAiHelperClick = () => { },
  } = props;
  const [isFocus, setIsFocus] = useState<boolean>(false);
  const [isImageEye, setIsImageEye] = useState<boolean>(false);
  const bgIconStyle = bgIcon
    ? (bgIconPosition === 'left'
      ? {
        paddingLeft: '44px',
        background: `url(${bgIcon}) 16px center no-repeat`,
        backgroundPosition: '16px center',
      }
      : {
        paddingRight: '44px',
        background: `url(${bgIcon}) right 16px center no-repeat`,
        backgroundPosition: 'right 16px center',
      })
    : bgText ?
      (bgIconPosition === 'left'
        ? {
          paddingLeft: '44px',
        }
        : {
          paddingRight: '44px',
        }) : {};



  if (insideBtn) {
    style['width'] = '350px';
  } else {
    style['width'] = '100%';
  }

  if (verified && !bgIcon) {
    style['background'] = `url(${imgURL['green-tick']}) right 16px center no-repeat`;
    style['backgroundPosition'] = 'right 16px center';
    style['paddingRight'] = '44px';
    style['borderColor'] = 'green';

  } else {
    style['background'] = '';
    style['backgroundPosition'] = '';
    style['paddingRight'] = '';
    style['borderColor'] = '';
  }


  const maxLengthCheck = (object) => {
    if (maxlength && object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };
  const openEyeStyle = {
    background: `url(${imgURL['open-eye']}) 0 0 no-repeat`,
  };

  const closeEyeStyle = {
    background: `url(${imgURL['close-eye']}) 0 0 no-repeat`,
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    if (type === 'number' && Number(value) < 0) {
      return;
    }
    handleChange(event);
  };

  const [isAihelperVisible, setIsAihelperVisible] = useState<boolean>(false);

  useEffect(() => {
    if (showAiHelperOnFocus) {
      setIsAihelperVisible(isFocus);
    }
  }, [isFocus]);

  return (
    <div
      className={`form-group ${error ? 'error-field' : isFocus ? 'input-focus' : ''
        } ${formGroupClassName || ''}`}
    >
      {forgotPassword && forgotPassword}
      {label && (
        <label>
          {label}
          {isRequired && <em>*</em>}
          {labelTooltip && (
            <Tooltip
              placement="right"
              overlayInnerStyle={{ width: 330 }}
              color='#fff'
              title={props.labelTooltip}
            >
              <img src={imgURL["info-icon-light"]} alt="info-icon" style={{ marginLeft: "5px", marginBottom: "3px" }} />
            </Tooltip>
          )}
        </label>
      )}
      <div className='input-row'>
        <input
          id={id}
          name={props.name}
          style={{ ...style, ...bgIconStyle }}
          type={(type !== 'password' && !isMasked) ? type : isImageEye ? 'text' : 'password'}
          value={value || ''}
          disabled={readonly}
          readOnly={verified}
          min={props?.min}
          max={props?.max}
          maxLength={maxlength}
          onInput={maxLengthCheck}
          placeholder={placeholder}
          className={`form-control ${className}`}
          onChange={handleInputChange}
          onFocus={() => setIsFocus(true)}
          onBlur={(e) => {
            setIsFocus(false);
            onBlur(e);
          }}
          onPaste={(e) => !allowPaste && e.preventDefault()}
        />
        {isAihelperVisible && showAiHelperOnFocus && (
          <div className='ai-helper'
            onMouseDown={(e) => {
              e.preventDefault();
              onAiHelperClick();
            }}>
            <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.2227 16.9702L13.5 19.5L12.7773 16.9702C12.5906 16.3168 12.2404 15.7217 11.7598 15.2411C11.2792 14.7605 10.6841 14.4103 10.0307 14.2236L7.5 13.5L10.0298 12.7773C10.6832 12.5906 11.2783 12.2404 11.7589 11.7598C12.2395 11.2792 12.5897 10.6841 12.7764 10.0307L13.5 7.5L14.2227 10.0298C14.4094 10.6832 14.7596 11.2783 15.2402 11.7589C15.7208 12.2395 16.3159 12.5897 16.9693 12.7764L19.5 13.5L16.9702 14.2227C16.3168 14.4094 15.7217 14.7596 15.2411 15.2402C14.7605 15.7208 14.4103 16.3159 14.2236 16.9693L14.2227 16.9702Z" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" stroke="#9395A1" />
              <circle cx="13.5" cy="13.5" r="12.75" stroke="#9395A1" strokeOpacity="0.32" strokeWidth="1.5" />
            </svg>
          </div>
        )}
      </div>
      {error && <div className='error'>{errorMessage}</div>}
      {(type === 'password' || isMasked) && allowToggleVisibility && (
        <span
          onClick={() => setIsImageEye(!isImageEye)}
          style={isImageEye ? openEyeStyle : closeEyeStyle}
          className='eye'
        ></span>
      )}

      {
        insideBtn ? <span className={`inside-btn ${customInsideBtnClass ? customInsideBtnClass : ''}`} onClick={insideBtnOnClick}>{insideBtnTxt}</span> : <></>
      }
      {bgText && (
        <span className={`bg-text ${bgIconPosition === 'left' ? 'bg-text-left' : 'bg-text-right'}`}>
          {bgText}
        </span>
      )}
      {verified && verifiedMessage && <div className='verified-message'>{verifiedMessage}</div>}


      {sideNote && <div className='sidenote'>{sideNote}</div>}

    </div>
  );
};

export default TextInput;
